import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';

type CallToActionProps = {
  eyebrow?: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaTo: string;
  external?: boolean;
  titleAs?: 'h1' | 'h2';
  className?: string;
};

export const CallToAction = ({
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaTo,
  external = false,
  titleAs = 'h2',
  className
}: CallToActionProps) => {
  const TitleTag = titleAs;

  return (
    <section className={cn('section section--light', className)}>
      <div className="container">
        <div className="cta-panel">
          <div className="cta-panel__content">
            {eyebrow ? <span className="cta-panel__eyebrow">{eyebrow}</span> : null}
            <TitleTag className="cta-panel__title">{title}</TitleTag>
            <p className="cta-panel__text">{description}</p>
          </div>
          {external ? (
            <a className="btn btn--primary cta-panel__button" href={ctaTo} target="_blank" rel="noopener noreferrer">
              {ctaLabel}
            </a>
          ) : (
            <Link className="btn btn--primary cta-panel__button" to={ctaTo}>
              {ctaLabel}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};
